import { SettingsIcon } from '../icons/settings';

export const Sidebar = (ps: { children?: React.ReactNode }) => {
  return (
    <div className="relative w-1/4 py-4 px-8 flex flex-col justify-start">
      <h2 className="text-xl font-bold flex items-center gap-2">
        <SettingsIcon className="w-8 h-8 fill-black" />
        Impostazioni
      </h2>
      {ps.children}
    </div>
  );
};
